import React from 'react';

import Layout from '../components/Layout';
import Scroll from '../components/Scroll';

import config from '../../config';
import Footer from '../components/Footer';
import SocialLinks from '../components/SocialLinks';
import Subscribe from '../components/Subscribe';
import Header from '../components/Header';

import logo from '../assets/images/logo.png';
import tablet from '../assets/images/tablet2.png';
import aboutImage from '../assets/images/kam-chauhan/kam-chauhan-social-media-136.jpg';
import testimonial1 from '../assets/images/kam-chauhan/kam-chauhan-social-media-117.jpg';
import testimonial2 from '../assets/images/kam-chauhan/kam-chauhan-social-media-122.jpg';
import bgMaster from '../assets/images/kam-chauhan/kam-chauhan-social-media-113.jpg';

const IndexPage = () => (
	<Layout>
		<Header />

		<header className="masthead">
			<div className="container d-flex h-100 align-items-center">
				<div className="mx-auto text-left">
					{/* <img className="img-fluid d-block" src={logo} alt="" /> */}
					<div className="col-lg-8 col-md-8 mx-auto">
						<h3 className="text-white text-left mb-3">
							I help non-profit & social impact organisations get raving
							fans and sparking conversations about your mission with clever
							marketing.
						</h3>
						<a
							href="https://calendly.com/kamc/meeting-with-kam"
							className="btn btn-primary mb-5 p-3"
						>
							Book a call
						</a>
					</div>
					<div className="text-center">
						<Scroll type="id" element="about">
							<a href="#about">
								<i className="fa fa-angle-down fa-4x"></i>
							</a>
						</Scroll>
					</div>
				</div>
			</div>
		</header>

		<section id="about" className="about-section">
			<div className="container">
				<div className="row">
					<div className="col-lg-10 mx-auto">
						<h2 className="color-primary-caramel mb-4">
							Hello, I'm Kam Chauhan, a passionate coffee-loving bookworm with a
							deep-rooted commitment to helping organisations drive positive
							change in our world. As a marketer my mission is to empower people
							like you to amplify your message and create a lasting social
							impact.
						</h2>
					</div>
				</div>

				<div className="row no-gutters">
					<div className="col-lg-6 mb-5">
						<img className="img-fluid" src={tablet} alt="" />
					</div>
					<div className="col-lg-6 order-lg-first mb-5">
						<div className="h-100">
							<div className="d-flex h-100">
								<div className="w-100 my-auto m-5">
									<a
										href="strategies-for-non-profits"
										class="btn btn-primary mb-5 p-3"
									>
										Grab your swipe file here
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section id="idealclient" className="text-left mt-5">
			<div className="container">
				<div className="row">
					<div className="col-lg-8 mx-auto">
						<h4 className="color-primary-caramel mb-4">
							You're leading a non-profit or social impact organisation which is
							slowly growing however you're feeling stuck getting pulled in all
							directions.
						</h4>
					</div>
					<div className="col-lg-8 mx-auto">
						<ul>
							<li className="mb-4">
								Devoting endless hours to your mission but not experiencing the
								growth you envision?
							</li>
							<li className="mb-4">
								Engaging in sporadic marketing efforts without a comprehensive
								strategy?
							</li>
							<li className="mb-4">
								Searching for specialised support tailored to your unique
								organisation?
							</li>
						</ul>

						<p className="mb-4">
							I specialise in serving non-profit and social impact
							organisations, and I recognise that a one-size-fits-all marketing
							approach doesn't cut it. I take the time to truly understand your
							organisation and its distinctive needs before charting a path
							forward.
						</p>
						<p className="mb-4">Curious to learn more? Let's connect.</p>
						<a
							href="https://calendly.com/kamc/meeting-with-kam"
							className="btn btn-primary mb-5 p-3"
						>
							Book a call
						</a>
					</div>
				</div>
			</div>
		</section>

		<section id="services" className="bg-light pt-5">
			<div className="container">
				<div className="row">
					<div className="col-lg-8 mx-auto">
						<h4 className="color-primary-caramel mb-4">
							<a href="services">Ready to get started?</a>
						</h4>
						<h4 className="color-primary-caramel mb-4">
							<a href="services">Read more about my services</a>
						</h4>
					</div>
				</div>
				<div className="row mb-4 mb-lg-5">
					<div className="col-lg-4">
						<div className="bg-color-primary-blue text-center h-100 project p-4">
							<div className="d-flex h-100">
								<div className="project-text w-100 my-auto text-center text-lg-left">
									<h4>
										<a href="services#outsourced-marketing-director">
											Outsourced Marketing Director
										</a>
									</h4>
									<p className="mb-0 text-white-50">
										This is where work with you to create a tailored marketing
										strategy and actively work alongside your team to achieve
										the desired result.
									</p>
									<a href="services#outsourced-marketing-director">
										Read more...
									</a>
								</div>
							</div>
						</div>
					</div>

					<div className="col-lg-4">
						<div className="bg-color-primary-blue text-center h-100 project p-4">
							<div className="d-flex h-100">
								<div className="project-text w-100 my-auto text-center text-lg-left">
									<h4>
										<a href="services#training-mentor">
											Marketing Trainer / Mentor
										</a>
									</h4>
									<p className="mb-0 text-white-50">
										Whether you already have a dedicated in-house marketing
										professional or prefer to handle day-to-day marketing
										activities yourself, this is the ideal solution for those
										seeking support and training to effectively implement their
										marketing strategy.{' '}
									</p>
									<a href="services#training-mentor">Read more...</a>
								</div>
							</div>
						</div>
					</div>

					<div className="col-lg-4">
						<div className="bg-color-primary-blue text-center h-100 project p-4">
							<div className="d-flex h-100">
								<div className="project-text w-100 my-auto text-center text-lg-left">
									<h4>
										<a href="services#employee-engagement-marketing-training">
											Employee Engagement Marketing Training
										</a>
									</h4>
									<p className="mb-0 text-white-50">
										Make your employees your biggest marketing asset! With my
										bespoke training, your employees will confidently use social
										media to showcase the work that your organisation does and
										increase your visibility.{' '}
									</p>
									<a href="services#employee-engagement-marketing-training">
										Read more...
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section id="testimonial" className="about-section">
			<div className="container">
				<div className="row">
					<div className="col-lg-8 mx-auto">
						<h2 className="color-primary-caramel mb-4">
							<i className="fas fa-quote-left fa-lg me-2 pr-2 color-primary-caramel"></i>
							A really positive experience all round.
						</h2>
						<p className="text-white-50 mb-5">
							<i className="fas fa-quote-left fa-lg me-2 pr-2 color-primary-caramel"></i>
							We had a very positive and successful experience working with Kam.
							She clearly understands how to become successful through social
							media and other online channels, and combined with the research
							which she undertook about our charity, Kam provided a truly
							bespoke training package which helped us to see results quickly
							and gave us the tools to set ourselves up for the long term. We
							would absolutely recommend Kam for any charity or organisation
							which is looking to reach new audiences or engage with existing
							audiences in a way which complements and helps rather than simply
							adds to the workload of a small team. A really positive experience
							all round.
						</p>
						<p className="text-white-50 mb-5">
							- Jennifer Allison - Deputy Director Army Museums Ogilby Trust
						</p>
					</div>
				</div>
			</div>
		</section>

		<SocialLinks />
		<Footer />
	</Layout>
);

export default IndexPage;
